import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

interface AuditFiltersState {
  // Search
  searchTerm: string
  debouncedSearch: string

  // Filters
  action: string
  resourceType: string
  status: string
  startDate: string
  endDate: string

  // Pagination
  currentPage: number
  pageSize: number

  // UI
  isDrawerOpen: boolean

  // Actions
  setSearchTerm: (term: string) => void
  setDebouncedSearch: (term: string) => void
  setAction: (action: string) => void
  setResourceType: (type: string) => void
  setStatus: (status: string) => void
  setDateRange: (start: string, end: string) => void
  setCurrentPage: (page: number) => void
  toggleDrawer: () => void
  resetFilters: () => void
}

const initialState = {
  searchTerm: '',
  debouncedSearch: '',
  action: '',
  resourceType: '',
  status: '',
  startDate: '',
  endDate: '',
  currentPage: 0,
  pageSize: 50,
  isDrawerOpen: false,
}

export const useAuditFiltersStore = create<AuditFiltersState>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,

        setSearchTerm: (searchTerm) => set({ searchTerm }),
        setDebouncedSearch: (debouncedSearch) => set({ debouncedSearch }),
        setAction: (action) => set({ action, currentPage: 0 }),
        setResourceType: (resourceType) => set({ resourceType, currentPage: 0 }),
        setStatus: (status) => set({ status, currentPage: 0 }),
        setDateRange: (startDate, endDate) => set({ startDate, endDate, currentPage: 0 }),
        setCurrentPage: (currentPage) => set({ currentPage }),
        toggleDrawer: () => set((state) => ({ isDrawerOpen: !state.isDrawerOpen })),
        resetFilters: () => set({ ...initialState, isDrawerOpen: false }),
      }),
      {
        name: 'audit-filters',
        partialize: (state) => ({
          // Only persist filters, not UI state
          action: state.action,
          resourceType: state.resourceType,
          status: state.status,
          startDate: state.startDate,
          endDate: state.endDate,
        })
      }
    ),
    { name: 'AuditFiltersStore' }
  )
)
